import * as _ from 'underscore';
import { util } from '../util';
import { ALLOWED_LANGUAGES, DEFAULT_LANGUAGE } from './language-data.service';
import { Inject, Injectable } from '@angular/core';
import { IExtendedWindow } from '../../../type_definitions/datatypes';
import { GaWebStorageService } from '../services/storage/ga-web-storage.service';
import { TranslationService } from '../translation/translation.service';

const KEY_LANGUAGE:string = 'ga2.language';

@Injectable()
export class LanguageService {
  private _uiLanguage:string;
  
  constructor(
    @Inject(Window) private window:IExtendedWindow,
    private webStorage:GaWebStorageService,
    private translationService:TranslationService
  ) {
    /***/
  }

  public saveLanguage(language:string):void {
    if (util.isNullOrUndefined(language)) {
      language = DEFAULT_LANGUAGE;
    }
    this.webStorage.local.set(KEY_LANGUAGE, language);
  }

  public getUserLanguage():string {
    return this.webStorage.local.get(KEY_LANGUAGE);
  }

  public set uiLanguage(language:string) {
    this._uiLanguage = language;
  }

  public get uiLanguage():string {
    return this._uiLanguage;
  }

  public determineLanguage():string {
    const getBrowserLanguage:Function = () => {
      let browserLanguage:string;
      if (this.window.navigator) {
        if (this.window.navigator[ 'languages' ] && this.window.navigator[ 'languages' ].length) {
          browserLanguage = this.window.navigator[ 'languages' ][ 0 ];
        } else if (this.window.navigator[ 'language' ]) {
          browserLanguage = this.window.navigator[ 'language' ];
        } else if (this.window.navigator[ 'browserLanguage' ]) {
          browserLanguage = this.window.navigator[ 'browserLanguage' ];
        } else if (this.window.navigator[ 'systemLanguage' ]) {
          browserLanguage = this.window.navigator[ 'systemLanguage' ];
        } else if (this.window.navigator[ 'userLanguage' ]) {
          browserLanguage = this.window.navigator[ 'userLanguage' ];
        }
      }

      if (browserLanguage) {
        const matchLanguage:RegExpMatchArray = browserLanguage.match(/([a-z]{2})-.*/i);
        browserLanguage = matchLanguage && matchLanguage[ 1 ] && matchLanguage[ 1 ].toLowerCase();
        if (_.contains(ALLOWED_LANGUAGES, browserLanguage)) {
          return browserLanguage;
        }
      }
    };

    return this.getUserLanguage() || getBrowserLanguage() || DEFAULT_LANGUAGE;
  }

  public translateDatepicker():any {
    return {
      previousMonth: this.translationService.instant('GA.DATEPICKER.PREVIOUS_MONTH'),
      nextMonth: this.translationService.instant('GA.DATEPICKER.NEXT_MONTH'),
      months: [
        this.translationService.instant('GA.DATEPICKER.MONTHS.JANUARY'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.FEBRUARY'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.MARCH'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.APRIL'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.MAY'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.JUNE'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.JULY'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.AUGUST'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.SEPTEMBER'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.OCTOBER'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.NOVEMBER'),
        this.translationService.instant('GA.DATEPICKER.MONTHS.DECEMBER')
      ],
      weekdays: [
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.SUNDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.MONDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.TUESDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.WEDNESDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.THURSDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.FRIDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYS.SATURDAY')
      ],
      weekdaysShort: [
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.SUNDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.MONDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.TUESDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.WEDNESDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.THURSDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.FRIDAY'),
        this.translationService.instant('GA.DATEPICKER.WEEKDAYSSHORT.SATURDAY')
      ]
    };
  }
}